import React from "react";

export default function TermsOfService({ onClose }) {
  return (
    <div className="tos-overlay" onClick={onClose}>
      <div className="tos-modal" onClick={e => e.stopPropagation()}>
        <div className="tos-header">
          <h2>Terms of Service</h2>
          <button className="tos-close" onClick={onClose}>✕</button>
        </div>
        <div className="tos-body">
          <p className="tos-updated">Last updated: April 2026</p>

          <h3>1. Informational Use Only</h3>
          <p>Reports generated by this service are for informational purposes only. Nothing in any report constitutes professional business, legal, financial, real estate, or investment advice. You should consult qualified professionals before making any business or financial decision.</p>

          <h3>2. No Warranty on Accuracy</h3>
          <p>Data is sourced from third parties including Google Places and Foursquare. We make no representations or warranties, express or implied, regarding the accuracy, completeness, reliability, or timeliness of any data or report. Data may be outdated, incomplete, or unavailable in certain geographic areas.</p>

          <h3>3. Assumption of Risk</h3>
          <p>You acknowledge that any business decision you make — including decisions to open, purchase, lease, or invest in a business — is made solely at your own risk. We are not liable for any losses, damages, or costs arising from your use of or reliance on any report generated by this service.</p>

          <h3>4. No Professional Credentials</h3>
          <p>This service is not operated by licensed real estate agents, business brokers, financial advisors, or any other licensed professionals. Reports are generated using AI-assisted analysis of publicly available data and do not substitute for a professional feasibility study or site survey.</p>

          <h3>5. Limitation of Liability</h3>
          <p>To the fullest extent permitted by law, our total liability to you for any claim arising from your use of this service shall not exceed the amount you paid for the report giving rise to the claim.</p>

          <h3>6. Refunds</h3>
          <p>If a report fails to generate due to a system error, your payment will be refunded automatically. All other sales are final. Because reports are generated and delivered immediately upon payment, we do not offer refunds for completed reports.</p>

          <h3>7. Changes to These Terms</h3>
          <p>We reserve the right to update these terms at any time. Continued use of the service constitutes acceptance of the current terms.</p>

          <h3>8. Contact</h3>
          <p>For questions about these terms, contact us at <a href="mailto:raym.agent@gmail.com">raym.agent@gmail.com</a>.</p>
        </div>
        <div className="tos-footer">
          <button className="btn-sec" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
